export default "__VITE_ASSET__04b99c01__"